import React, { useState } from "react";
//components
import { Link, Navigate } from "react-router-dom";
// img
import { InputSwitch } from "primereact/inputswitch";
import { getUserName, logout } from "../../../utils/auth";
import { useAppContext } from "../../../context/AppContext";

function DropdownProfile() {
  const [redirect, setRedirect] = useState(false);
  const [checked, setChecked] = useState(false);

  const user = getUserName();

  const { profilePhoto } = useAppContext();

  const logoutFunction = async () => {
    logout();
    setRedirect(true);
  };

  if (redirect) {
    return <Navigate to="/" />;
  }

  const displayName = user && user !== undefined ? user.split(" ").slice(0, 2).join(" ") : "Usuário";

  return (
    <div className="navbar-item navbar-user dropdown">
      <a
        href="#/"
        className="navbar-link dropdown-toggle d-flex align-items-center"
        data-bs-toggle="dropdown"
      >
        <img src={profilePhoto} alt="Foto de Perfil" />
        <span>
          <span className="d-none d-md-inline">
            {displayName}
          </span>
          <b className="caret"></b>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end px-3">
        <div style={{ cursor: 'pointer' }}>
          <Link to="/myAccount">
            <h6 className="dropdown-item">
              <i className="fa fa-user me-2"></i> Meu Perfil
            </h6>
          </Link>
        </div>
        {/* <div className="d-flex" style={{cursor: 'pointer'}}>
          <h6 className="dropdown-item"><i className="fa-solid fa-database me-2"></i> Banco Teste
          </h6>
          <div>
            <InputSwitch
              checked={checked}
              onChange={(e) => setChecked(e.value)}
            />
          </div>
        </div> */}
        <div style={{ cursor: 'pointer' }}>
          <h6 onClick={logoutFunction} className="dropdown-item">
            <i className="fa-solid fa-door-open me-2"></i> Sair
          </h6>
        </div>
      </div>
    </div>
  );
}

export default DropdownProfile;
